import { Component } from '@angular/core';
import { ReformatObject, Submenu } from 'src/app/core/interface/flow-builder.interface';
import { FlowBuilderService } from 'src/app/core/service/flow-builder.service';

@Component({
  selector: 'app-top-action-area',
  templateUrl: './top-action-area.component.html',
  styleUrls: ['./top-action-area.component.scss']
})
export class TopActionAreaComponent {

  public inputKey: any;
  public outputKey: any;
  public inputConnection: any = [];
  public outputConnection: any = [];
  public next: any;
  public previous: any;
  public formData: any = new FormData();


  constructor(
    public _flowBuilder: FlowBuilderService,
  ) { }


}
